export type DateFormats = 'yyyy-mm-dd' | 'mm-dd-yyyy' | 'dd-mm-yyyy' | 'mm/dd/yyyy hh:mm A'

interface FormatDateParams {
  date?: string | null | Date
  format?: DateFormats
  joiner?: string
}

export function formatDate({
  date = '',
  format = 'yyyy-mm-dd',
  joiner = '-',
}: FormatDateParams): string | null {
  try {
    if (!date || date === '') {
      return null
    }

    // Ensure date is a Date object, convert string to Date if necessary
    const d: Date = typeof date === 'string' ? new Date(date) : date
    if (isNaN(d.getTime())) return null // Handle invalid date cases

    let month: string = (d.getMonth() + 1).toString()
    let day: string = d.getDate().toString()
    const year: number = d.getFullYear()
    let hours: number = d.getHours()
    const minutes: string = d.getMinutes().toString().padStart(2, '0')

    // Pad month and day with leading zeros if necessary
    month = month.padStart(2, '0')
    day = day.padStart(2, '0')

    // Handle AM/PM format
    const isPM = hours >= 12
    const meridian = isPM ? 'PM' : 'AM'
    hours = hours % 12 || 12 // Convert 24-hour format to 12-hour

    let formatArray: string[] = []

    // Date Formatting
    if (format.includes('yyyy') && format.includes('mm') && format.includes('dd')) {
      if (format.startsWith('yyyy')) {
        formatArray = [year.toString(), month, day]
      } else if (format.startsWith('mm')) {
        formatArray = [month, day, year.toString()]
      } else if (format.startsWith('dd')) {
        formatArray = [day, month, year.toString()]
      }
    }

    let formattedDate = formatArray.join(joiner)

    // Time Formatting
    if (format.includes('hh') || format.includes('HH')) {
      const timeSeparator = format.includes(':') ? ':' : joiner
      const hourStr = hours.toString().padStart(2, '0')
      formattedDate += ` ${hourStr}${timeSeparator}${minutes}`

      if (format.includes('A')) {
        formattedDate += ` ${meridian}`
      }
    }

    return formattedDate
  } catch (error) {
    return ''
  }
}

export function formatLongDate(date?: string | Date | null): string {
  if (!date) return 'N/A'
  try {
    const d = typeof date === 'string' ? new Date(date) : date
    if (isNaN(d.getTime())) return 'Invalid Date'
    return d.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  } catch (error) {
    return 'Invalid Date'
  }
}
